import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab } from "semantic-ui-react";
import { getPublicRoles } from "../../../../actions/publicRoles/publicRoles";
import { changeUserAttribute, getAvailableRegions } from "../../../../actions/users/users";
import Regions from "./Regions";

const RegionsTab = ({ disabled, isExternal }) => {
  const dispatch = useDispatch();
  const [publicRoles, availableRegions, roles] = useSelector(({ users, publicRoles }) => [
    publicRoles.roles,
    users.availableRegions,
    users.userClaims.roles
  ]);
  useEffect(() => {
    dispatch(getAvailableRegions());
    dispatch(getPublicRoles());
  }, [dispatch]);
  const onPublicRegionJoin = roles =>
    dispatch(
      changeUserAttribute(
        "roles",
        roles,
        "Successfully joined.",
        "There was an error trying to join public regions. Please try again later."
      )
    );
  return (
    <Tab.Pane
      attached={false}
      style={{
        display: "inline-block"
      }}
      className="management-tab-pane"
      as="Segment"
    >
      <Regions
        userRegions={availableRegions}
        publicRoles={publicRoles.filter(
          publicRole =>
            !roles.some(
              userRole =>
                userRole.organizationId === publicRole.organizationId &&
                userRole.regionId === publicRole.regionId
            )
        )}
        onPublicRegionJoin={onPublicRegionJoin}
        disabled={disabled}
        isExternal={isExternal}
      />
    </Tab.Pane>
  );
};

export default RegionsTab;
